import React, { useState } from 'react';
import {
  getAuth,
  updatePassword,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './ChangePassword.css';

const ChangePassword = () => {
  const auth = getAuth();
  const user = auth.currentUser;
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Spinner loading

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!currentPassword || !newPassword) {
      setError('⚠️ Both fields are required.');
      setLoading(false);
      return;
    }

    if (newPassword.length < 6) {
      setError('❗ Password must be at least 6 characters.');
      setLoading(false);
      return;
    }

    if (currentPassword === newPassword) {
      setError('⚠️ New password cannot be the same as current password.');
      setLoading(false);
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, user.email, currentPassword);
      await updatePassword(user, newPassword);

      setCurrentPassword('');
      setNewPassword('');
      navigate('/password-changed-success');
    } catch (err) {
      if (
        err.code === 'auth/wrong-password' ||
        err.code === 'auth/invalid-credential'
      ) {
        setError('❌ Incorrect current password.');
      } else {
        setError('❌ ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <p className="text-center mt-5">
        You must be logged in to change your password.
      </p>
    );
  }

  return (
    <div className="change-password-wrapper">
      <div className="card change-password-card shadow">
        <h4 className="mb-4 text-center">Change Password</h4>
        <form onSubmit={handleChangePassword}>
          {/* Current Password */}
          <div className="mb-3">
            <label htmlFor="currentPassword" className="form-label">
              Current Password
            </label>
            <div className="input-group">
              <input
                type={showCurrentPassword ? 'text' : 'password'}
                id="currentPassword"
                className="form-control"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowCurrentPassword((prev) => !prev)}
              >
                {showCurrentPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {/* New Password */}
          <div className="mb-3">
            <label htmlFor="newPassword" className="form-label">
              New Password
            </label>
            <div className="input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                id="newPassword"
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {/* Submit Button with Spinner */}
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Updating...
              </>
            ) : (
              'Update Password'
            )}
          </button>
        </form>

        {error && <div className="alert alert-danger mt-3">{error}</div>}
      </div>
    </div>
  );
};

export default ChangePassword;
